import { render, staticRenderFns } from "./MatchingTable.vue?vue&type=template&id=c6202b3c&scoped=true"
import script from "./MatchingTable.vue?vue&type=script&lang=js"
export * from "./MatchingTable.vue?vue&type=script&lang=js"
import style0 from "./MatchingTable.vue?vue&type=style&index=0&id=c6202b3c&prod&lang=scss&scoped=true"
import style1 from "./MatchingTable.vue?vue&type=style&index=1&id=c6202b3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6202b3c",
  null
  
)

export default component.exports